const removeCPFCNPJMask = (CPFCNPJ) => { return CPFCNPJ.replaceAll(/\D/g, ""); };

export default removeCPFCNPJMask;